module.exports = require("express");


//////////////////
// WEBPACK FOOTER
// external "express"
// module id = 28
// module chunks = 0